export const BUSINESS_CENTER_CATEGORIES = [
  'officeRent',
  'officeSale',
  'freeAppointmentObjectRent',
  'freeAppointmentObjectSale',
  'shoppingAreaRent',
  'shoppingAreaSale',
  'warehouseRent',
  'warehouseSale',
];
